var _path, _path2, _path3, _path4, _circle, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgKp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#91dc5a",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v57.188H0zM0 369.48h512v57.177H0z",
  fill: "#0052b4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 165.215h512v181.582H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 190.33,
  cy: 255.994,
  r: 65.668,
  fill: "#f0f0f0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M190.332 190.332l14.734 45.346h47.757l-38.65 28.028 14.849 45.481-38.69-28.16-38.631 28.107 14.79-45.428-38.616-28.028h47.722z"
})));

export default SvgKp;